import React, { FunctionComponent, useEffect } from 'react'
import styles from './ProfilePage.module.sass'
import { useRootDispatch, useRootSelector } from '../../../../utils/hooks'
import Switch from '../../../controls/Switch/Switch'
import { Table } from '../../../data-components/Table/Table/Table'
import { Column } from '../../../data-components/Table/Column'
import { toBool } from '../../../../utils/utils'
import { UserIcon } from '../../../data-components/elements/UserElement/UserElement'
import { profileActions } from '../../../../redux/pages/settings/profile'
import { NotificationMethod, NotificationSettingsRow } from '../../../../responses/profile'
import { groupBy } from 'fp-ts/es6/NonEmptyArray'
import { userActions } from '../../../../redux/global/user/user-actions'
import { batch } from 'react-redux'

const ProfilePage: FunctionComponent = () => {
    const dispatch = useRootDispatch()
    const user = useRootSelector(state => state.global.user.data)
    const categories = useRootSelector(state =>
        groupBy<NotificationSettingsRow>(setting => setting.category)(state.pages.settings.profile.notificationSettings)
    )
    const methods = useRootSelector(state => state.pages.settings.profile.notificationMethods)

    useEffect(() => {
        if (user?.id) {
            batch(() => {
                dispatch(profileActions.notificationSettings.request(user.id))
                dispatch(profileActions.notificationMethods.request(user.id))
            })
        }
    }, [dispatch, user?.id])

    return <div className={styles.page}>
        <UserIcon className={styles.icon} size={'medium'} user={user}/>
        <div className={styles.name}>{user?.name}</div>
        <div>{user?.roles.map(role => role.title).join(', ')}</div>

        <div className={styles.header}>Получать уведомления</div>
        <Table
            withoutHeader
            className={styles.table}
            data={methods}
        >
            <Column<NotificationMethod> cellRenderer={notification => notification.name}/>
            <Column<NotificationMethod>
                cellRenderer={method => <Switch
                    value={!!user?.notification_method_settings[method.key]}
                    onChange={value => dispatch(userActions.update.request({
                        notification_method_settings: {
                            [method.key]: toBool(value),
                        }
                    }))}
                />}
            />
        </Table>

        <div className={styles.header}>Настройка уведомлений</div>
        {
            Object.entries(categories).map(([category, settings]) => <div key={category}>
                <div className={styles.subheader}>{category}</div>
                {
                    <Table
                        withoutHeader
                        className={styles.table}
                        data={settings}
                    >
                        <Column<NotificationSettingsRow> cellRenderer={notification => notification.name}/>
                        <Column<NotificationSettingsRow>
                            cellRenderer={notification => <Switch
                                value={!!user?.notification_settings[notification.key]}
                                onChange={value => dispatch(userActions.update.request({
                                    notification_settings: {
                                        [notification.key]: toBool(value),
                                    }
                                }))}
                            />}
                        />
                    </Table>
                }
            </div>)
        }
    </div>
}

export default ProfilePage